import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { Divider, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowDownIcon } from "src/components/ui/svgIcon/CustomIcons";
import DownloadFile from "src/components/form/manage-file-image/DownloadFile";
import { useState } from "react";

export default function FAQAccardion({ question, answer, index }) {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const content = `panel${index}bh-content`;
  const header = `panel${index}bh-header`;

  return (
    <Stack sx={{ marginBottom: 0.5 }}>
      <Accordion
        expanded={expanded === `panel${index}`}
        onChange={handleChange(`panel${index}`)}
        sx={{ backgroundColor: "#091D35" }}
      >
        <AccordionSummary
          expandIcon={<ArrowDownIcon color={theme.palette.primary.main} />}
          aria-controls={content}
          id={header}
        >
          <Typography variant="subtitle2" fontWeight="fontWeightMedium">
            {question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {answer?.edges?.map((item) => (
            <Stack key={item?.node?.id} p={1} my={1}>
              <Typography variant="body1" color="text.secondary" sx={{ textAlign: "left" }}>
                {item?.node?.text}
              </Typography>
              <Stack width="100%" p={1.5} sx={{ borderRadius: 1.5 }} alignItems="start" justifyContent="center">
                {item?.node?.file ? <DownloadFile file={item?.node?.file} fileUrl={item?.node?.fileUrl} /> : null}
              </Stack>
              {/* <Divider sx={{ width: "100%" }} /> */}
            </Stack>
          ))}
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
